import React from 'react';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

const MenuComplete = [
  {
    title: 'Dashboard',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text',
    permission: ''
  },
  {
    title: 'Reports',
    path: '/reports',
    icon: <AiIcons.AiOutlinePieChart />,
    cName: 'nav-text',
    permission: '',
    subMenu: [
      {
        title: 'Sales Report',
        path: '/reports',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'Reports'
      },
      {
        title: 'Google Analytics',
        path: '/reports/analytics',
        icon: <AiIcons.AiOutlineBarChart />,
        cName: 'nav-text',
        permission: 'Reports'
      },
      {
        title: 'Subscriptions Report',
        path: '/reports/subscriptions',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'Reports'
      }
    ]
  },
  {
    title: 'Clients',
    path: '/Clients',
    icon: <AiIcons.AiOutlineProfile />,
    cName: 'nav-text',
    permission: 'Clients'
  },
  {
    title: 'Orders',
    path: '/orders',
    icon: <AiIcons.AiOutlineProfile />,
    cName: 'nav-text',
    permission: 'Orders'
  },
  {
    title: 'Plans',
    path: '/Plans',
    icon: <AiIcons.AiOutlineProfile />,
    cName: 'nav-text',
    permission: 'Plans'
  },
  {
    title: 'Templates',
    path: '/Templates',
    icon: <AiIcons.AiOutlineProfile />,
    cName: 'nav-text',
    permission: 'Templates'
  },
  {
    title: 'MonitorUrls',
    path: '/MonitorUrls',
    icon: <AiIcons.AiOutlineProfile />,
    cName: 'nav-text',
    permission: 'MonitorUrls'
  },
  {
    title: 'Inbursa',
    path: '/inbursa',
    icon: <AiIcons.AiOutlineLineChart />,
    cName: 'nav-text',
    permission: '',
    subMenu: [
      {
        title: 'Inbursa Users',
        path: '/reports/inbursausers',
        icon: <AiIcons.AiOutlineTeam />,
        cName: 'nav-text',
        permission: 'InbursaUsers'
      },
      {
        title: 'Seguimiento',
        path: '/inbursa/prospects',
        icon: <AiIcons.AiOutlineUsergroupAdd />,
        cName: 'nav-text',
        permission: 'InbursaUsers'
      },
      {
        title: 'Inbursa Templates',
        path: '/inbursa/templates',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'InbursaTemplates'
      },
      {
        title: 'Users Login',
        path: '/inbursa/userslogin',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'InbursaUsersLogin'
      }
    ]
  },
  {
    title: 'Catalogs',
    path: '/catalogs',
    icon: <AiIcons.AiOutlinePieChart />,
    cName: 'nav-text',
    permission: '',
    subMenu: [
      {
        title: 'Payment Methods',
        path: '/catalogs/paymethods',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'PayMethods'
      }
    ]
  },
  {
    title: 'URP',
    path: '/urp',
    icon: <AiIcons.AiOutlineProfile />,
    cName: 'nav-text',
    permission: '',
    subMenu: [
      {
        title: 'Users',
        path: '/Users',
        icon: <AiIcons.AiOutlineTeam />,
        cName: 'nav-text',
        permission: 'Users'
      },
      {
        title: 'Roles',
        path: '/Roles',
        icon: <IoIcons.IoIosPaper />,
        cName: 'nav-text',
        permission: 'Roles'
      }
    ]
  },
  {
    title: 'Logs',
    path: '/logs',
    icon: <IoIcons.IoIosPaper />,
    cName: 'nav-text',
    permission: '',
    subMenu: [
      {
        title: 'Logs',
        path: '/logs',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'Logs'
      },
      {
        title: 'Orders TimeOut',
        path: '/logs/orders',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'Logs'
      },
      {
        title: 'Subscriptions Logs',
        path: '/logs/subscriptions',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'Logs'
      },
      {
        title: 'List SSL',
        path: '/logs/listSsl',
        icon: <AiIcons.AiOutlineLineChart />,
        cName: 'nav-text',
        permission: 'ListSsl'
      }
    ]
  }
];
export default MenuComplete;

export const GetCurrentModuleName = () => {
  const currentPath = window.location.pathname;
  const filteredMenu = MenuComplete.filter(item => item.path !== '/');

  for (const item of filteredMenu) {
    if (currentPath.startsWith(item.path)) {
      if (item.subMenu && item.subMenu.length > 0) {
        for (const subItem of item.subMenu) {
          if (currentPath === subItem.path) {
            return subItem.title;
          }
        }
        return item.title;
      }
      return item.title;
    }
  }

  return '';
};